import { keyframes } from "@emotion/react";
import { Box, Typography } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface TypingIndicatorProps {
  senderName: string;
}

const typingDotsAnimation = keyframes`
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-8px);
    opacity: 1;
  }
`;

const typingTextAnimation = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

const TypingIndicator = ({ senderName }: TypingIndicatorProps) => {
  const { colors } = useCelleraTheme();
  return (
    <Box
      sx={{
        padding: 2,
        border: `1px solid ${colors.border.light}`,
        borderRadius: "16px",
        borderBottomLeftRadius: "0px",
        backgroundColor: colors.background.paper,
        display: "flex",
        alignItems: "center",
        gap: 1,
        width: "fit-content",
        alignSelf: "flex-start",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: "14px",
          color: colors.text.secondary,
          fontStyle: "italic",
          animation: `${typingTextAnimation} 1.5s infinite ease-in-out`,
        }}
      >
        {senderName} is typing
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          alignItems: "center",
          ml: 0.5,
        }}
      >
        {[0, 1, 2].map((index) => (
          <Box
            key={index}
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: colors.text.secondary,
              animation: `${typingDotsAnimation} 1.4s infinite ease-in-out`,
              animationDelay: `${index * 0.2}s`,
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TypingIndicator;
